import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&id=c64aa8f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64aa8f8"]])

export default __exports__